/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcArticleResponse } from '../../models/bc-article-response';

export interface GetProductArticles$Params {
  id: number;
}

export function getProductArticles(http: HttpClient, rootUrl: string, params: GetProductArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcArticleResponse>>> {
  const rb = new RequestBuilder(rootUrl, getProductArticles.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcArticleResponse>>;
    })
  );
}

getProductArticles.PATH = '/business-central/product/{id}/articles';
